import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { createDefaultPageData } from 'types/rest/IPageData';
import { getExpectedInternalTransfersAsync } from '../../../API/accounting/getExpectedInternalTransfersAsync';

export const { slice: expectedInternalTransfersSlice, asyncAction: getExpectedInternalTransfersAction } =
  createAsyncSliceWithDataAndQuery(
    'expectedInternalTransfersSlice',
    getExpectedInternalTransfersAsync,
    createDefaultPageData()
  );
